export default {
  text: 'Vous avez passé une commande il y a moins de 15 minutes ! Confirmez si vous souhaitez continuer avec cette nouvelle commande ou gérer votre commande existante.',
  buttons: {
    see_existing_order: 'Voir la commande existante',
    proceed_new_order: 'Continuer la nouvelle commande',
  },
};
